import { jsx as s } from "react/jsx-runtime";
import { SearchIcon as F } from "../../../icons/index.es.js";
import { forwardRef as j, useState as y, useCallback as f, useEffect as B, useMemo as p } from "react";
import { mergeRefs as C } from "../../../utils/refs.es.js";
import { Input as M } from "../../../atoms/Input/Input.container.es.js";
import { Spinner as O } from "@chakra-ui/react";
import { useDropdownContext as P } from "../../Dropdown/Dropdown.context.es.js";
const K = j(
  ({
    ariaLabel: V,
    defaultValue: t = "",
    isDisabled: l,
    isError: b,
    isLoading: n,
    isSmartData: a,
    leftAddon: d,
    onBlur: h,
    onChange: e,
    onClear: o,
    onFocus: x,
    onRetry: v,
    trackId: g,
    ...I
  }, R) => {
    const [r, i] = y(t), { refs: S, getReferenceProps: k, onChange: c } = P(), w = f(() => {
      i(""), e(""), o == null || o();
    }, [e, o]);
    B(() => {
      i(t), e(t);
    }, [t]);
    const z = f(
      (m) => {
        const { value: u = "" } = m.target;
        c(m), e(u), i(u);
      },
      [e, c]
    ), A = p(() => r.length > 0, [r]), E = p(() => {
      if (!r.length)
        return /* @__PURE__ */ s(F, { color: "primary.500", boxSize: 4, "aria-label": "search-icon" });
      if (n)
        return /* @__PURE__ */ s(O, { boxSize: 4 });
    }, [n, r]);
    return /* @__PURE__ */ s(
      M,
      {
        ...k({
          ref: C(R, S.setReference)
        }),
        autoComplete: "off",
        disableFormik: !0,
        isDisabled: l,
        sx: {
          '&[data-disabled="true"]': {
            pointerEvents: "none"
          }
        },
        isFullWidth: !0,
        isLoading: n,
        isSmartData: a,
        leftAddon: d,
        onBlur: h,
        onChange: z,
        onClear: w,
        onFocus: x,
        onRetry: v,
        role: "combobox",
        "track-id": g,
        value: r,
        variant: b && a ? "error" : void 0,
        withClearButton: A,
        ...I,
        rightAddon: E
      }
    );
  }
);
export {
  K as AutocompleteInput
};
//# sourceMappingURL=AutocompleteInput.es.js.map
